import Swiper from 'swiper';
import {Navigation, Thumbs} from 'swiper/modules';
Swiper.use([Navigation, Thumbs]);
import lightGallery from 'lightgallery';

const miniSwiper = new Swiper('.mini-image-swiper',{
  loop: true,
  spaceBetween: 10,
  slidesPerView: 3,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});
const bigSwiper = new Swiper('.big-image-swiper',{
    loop: true,
    spaceBetween: 10,
    thumbs:{
        swiper: miniSwiper,
    },
    navigation: {
        prevEl: ".image-swiper-prev",
        nextEl: ".image-swiper-next"
    }
});

lightGallery(document.getElementById('big-image-wrapper'),{
    prevHtml: '<div class="previous-arrow arrow-white"></div>',
    nextHtml: '<div class="next-arrow arrow-white"></div>',
    closeOnTap: true,
    download: false
});
